import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import "../css/modal.css";
import {
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";

type RightSidePreviewModalProps = {
  handleCancel: any;
  open: boolean;
  documentUrl: string | undefined | null;
};

const RightSidePreviewModal: React.FC<RightSidePreviewModalProps> = ({
  handleCancel,
  open,
  documentUrl,
}) => {
  const isPdf = documentUrl?.toLowerCase().endsWith(".pdf");
  const [zoomLevel, setZoomLevel] = useState(1);
  const [rotationAngle, setRotationAngle] = useState(0);

  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 3));
  };
  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => Math.max(prevZoom - 0.1, 0.5));
  };

  const handleRotateLeft = () => setRotationAngle((prev) => prev - 90);
  const handleRotateRight = () => setRotationAngle((prev) => prev + 90);

  useEffect(() => {
    setZoomLevel(1);
    setRotationAngle(0);
  }, [documentUrl]);

  return (
    <>
      {documentUrl && (
        <div className="right-side-modal">
          <Modal
            open={open}
            width={4000}
            onCancel={handleCancel}
            wrapClassName="patient-list-table-modal"
            style={{
              top: 2,
              left: 4,
              padding: 0,
              maxWidth: "100vw",
              height: "148vh",
            }}
            bodyStyle={{
              height: "calc(148vh)",
              overflow: "auto",
              padding: 0,
            }}
            footer={(_) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: isPdf ? "flex-end" : "space-between",
                }}
              >
                {!isPdf ? (
                  <div className="zoom-controls">
                    <Button
                      onClick={handleZoomOut}
                      disabled={zoomLevel <= 0.5}
                      style={{ marginRight: "0.5rem" }}
                    >
                      <ZoomOutOutlined />
                    </Button>
                    <Button onClick={handleZoomIn} disabled={zoomLevel >= 3}>
                      <ZoomInOutlined />
                    </Button>
                    <Button
                      onClick={handleRotateLeft}
                      style={{ marginLeft: 8 }}
                    >
                      <RotateLeftOutlined />
                    </Button>
                    <Button
                      onClick={handleRotateRight}
                      style={{ marginLeft: 8 }}
                    >
                      <RotateRightOutlined />
                    </Button>
                  </div>
                ) : (
                  ""
                )}
                <Button key="back" onClick={handleCancel}>
                  Cancel
                </Button>
              </div>
            )}
            className="right-side-modal"
          >
            {isPdf ? (
              <object
                style={{ height: "130vh", marginTop: "2rem" }}
                data={documentUrl}
                type="application/pdf"
                width="100%"
                height="100%"
              >
                <p>
                  Unable to display the file.{" "}
                  <a
                    href={documentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click here to view it
                  </a>
                  .
                </p>
              </object>
            ) : (
              <>
                <div
                  style={{
                    overflow: "auto",
                    width: "100%",
                    height: "130vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    marginTop: "2rem",
                  }}
                >
                  <img
                    src={documentUrl}
                    style={{
                      transform: `scale(${zoomLevel}) rotate(${rotationAngle}deg)`,
                      transformOrigin: "top center",
                      transition: "transform 0.3s ease",
                      maxWidth: "100%",
                      maxHeight: "100%",
                      // objectFit: "contain",
                    }}
                  />
                </div>
              </>
            )}
          </Modal>
        </div>
      )}
    </>
  );
};

export default RightSidePreviewModal;
